<mat-card>{{'statmentByUser' | translate}}</mat-card>



<div class="container" style="padding: 25px;">



    <mat-grid-list cols="8" rowHeight="50px">

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'user' | translate}}</mat-label>
                <mat-select [(value)]="selectedUser">
                    <mat-option *ngFor="let item of users" [value]="item.id">
                        {{item.userName}} - {{item.fullName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="fill" class="example-form-field">
                <mat-label>{{'enterDateRange' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" #fromDate>
                    <input matEndDate placeholder="End date" #toDate>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                        <button mat-raised-button color="primary" (click)="onApply()" matDateRangePickerApply>
                            {{'filter' | translate}}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </mat-grid-tile>

        <!-- <mat-grid-tile colspan="2">
            <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;">
                <mat-label>{{'transType' | translate}}</mat-label>
                <mat-select [(value)]="selectedTransType">
                    <mat-option value="0">الجميع</mat-option>
                    <mat-option value="1">ايداع</mat-option>
                    <mat-option value="2">سحب</mat-option>
                    <mat-option value="3">ارجاع</mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile> -->


        <mat-grid-tile colspan="2">

            <button mat-raised-button color="primary" (click)="onApply()" style="margin-left: 10px;">
                <mat-icon>search</mat-icon>
                {{'filter' | translate}}
            </button>
            <button mat-raised-button color="primary" [disabled]="reports.length == 0" (click)="Print()">
                <mat-icon>print</mat-icon>
                {{'print' | translate}}
            </button>

        </mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>


    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort id="usersOrderTransAllTable">

            <ng-container matColumnDef="orderId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'orderNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.date | date: 'dd/MM/yyyy hh:mm a'}} </td>
            </ng-container>

            <ng-container matColumnDef="transType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'transaction' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.transType}} </td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'amount' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.amount}} </td>
            </ng-container>

            <ng-container matColumnDef="prevBall">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'prevBall' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.prevBall}} </td>
            </ng-container>


            <ng-container matColumnDef="currBall">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'currBall' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.currBall}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
            </tr>

        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>